import { useTranslation } from "react-i18next";

// A&M Autopilot (ticket 1219547818089406): the Autopilot switches its own
// Zapier integration on and off (am_autopilot linkFunnels); Cockpit only
// shows it. No date: the row's updatedAt changes with every edit and Cockpit
// does not store when the Autopilot switched it on (Hamza, review 26.10.2026).
const AutopilotStatus = ({ integrations = [] }) => {
  const { t } = useTranslation();
  const active = integrations.some((integration) => integration.active);
  return (
    <div>
      <div className={`fw-bold ${active ? "text-success" : "text-secondary"}`}>
        {active
          ? t("funnelIntegration.autopilot.active")
          : t("funnelIntegration.autopilot.inactive")}
      </div>
      <div className="text-secondary small mt-1">
        {t("funnelIntegration.autopilot.readOnly")}
      </div>
    </div>
  );
};

export default AutopilotStatus;
